import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'shortenName' })
export class shortenNamePipe implements PipeTransform {
	transform(value: string): string {
		if (!value) {
			return '';
		}
		const name = `${value
			.split(' ')
			.map((name) => name.slice(0, 1))
			.join('. ')}.`;
		return name;
	}
}
